import { useTranslation } from 'react-i18next';
import './ButtonsStyle.css';

export const DeleteButton = ({ onClick, disabled }) => {
    const { t } = useTranslation();
    return (
        <button className={'button--main danger-button'} onClick={onClick} disabled={disabled}>
            {t('common:buttons.delete')}
        </button>
    );
};
